import { createElement } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { ghDarkTheme, ghLightTheme } from './ghThemes';
import './fonts';
import './ghGlobal.css';

export { applyDefaultThemePreference } from './applyDefaultThemePreference';

// Naming these 'dark' / 'light' under pluginId 'app' produces the extension ids
// `theme:app/dark` and `theme:app/light`, which override Backstage's built-in
// themes of the same name — so the portal offers exactly these two.
const darkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Golden Hippo Dark',
      variant: 'dark',
      icon: createElement(DarkIcon),
      Provider: ({ children }) =>
        createElement(UnifiedThemeProvider, { theme: ghDarkTheme, children }),
    },
  },
});

const lightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Golden Hippo Light',
      variant: 'light',
      icon: createElement(LightIcon),
      Provider: ({ children }) =>
        createElement(UnifiedThemeProvider, { theme: ghLightTheme, children }),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [darkTheme, lightTheme],
});
